import React from 'react'

const Photo = ({ clickHandler = null , src }) => {

  return (
    <div className="imageGridItem">
      <a onClick={ clickHandler ? clickHandler.bind(this) : null }>
        <div className="imageWrapper" style={{backgroundImage: `url(${src})`}}>
        </div>
      </a>
    </div>
  );
};

export default Photo



// WEBPACK FOOTER //
// ./src/components/Outreach/Photo.js